import { colors } from 'components/styles/variables';
import { Theme, makeStyles } from '@material-ui/core/styles';
import { theme } from 'components/Shared/ThemeProviderWrapper';

const useNumberInputBoxStyles = makeStyles<Theme>(() => ({
  root: {
    width: '98px',
    [theme.breakpoints.down('xs')]: {
      width: '108px',
    },
    height: '36px',
    border: `1px solid ${colors.G2}`,
    borderRadius: '4px',
    padding: '8px',
    caretColor: `${colors.ALR1}`,
    '&:focus-within': {
      border: `1px solid ${colors.BLACK}`,
    },
    '& .MuiInput-input': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
        paddingBottom: 12,
        lineHeight: '26px',
      },
      lineHeight: '20px',
      fontSize: '14px',
      letterSpacing: '0.2px',
      textAlign: 'center',
      padding: 0,
      paddingBottom: 6,
    },
    '& .MuiInput-underline': {
      '&::before': {
        borderBottom: 'none',
      },
      '&::after': {
        borderBottom: 'none',
      },
      '&:hover': {
        '&::before': {
          borderBottom: 'none',
        },
      },
    },
  },
}));
export default useNumberInputBoxStyles;
